
import Vehicle from '@/models/vehicle'
import Vue from 'vue'

Vue.filter('findVehicles', (vehicleIds: number[], vehicles: Vehicle[]): Vehicle[] => {
  const result = []

  for (const vehicleId of vehicleIds) {
    const findVehicle = vehicles.find(vehicle => vehicle.id === vehicleId)

    if (findVehicle) {
      result.push(findVehicle)
    }
  }
  return result
})
